import InputNumber from '../inputNumber'
import { Input, InputProps, Select } from 'antd'
import { IOptionItem } from 'interfaces'
import { ReactNode } from 'react'
import styled from 'styled-components'

const StyledContainer = styled.div``

const StyleLabel = styled.label`
  font-weight: 600;
  color: #09101d;
`

const StyledSelectInput = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  &:hover,
  &:focus {
    .search-input,
    .wrap-select-btn {
      border-color: var(--color-primary-108);
    }
  }
`

const StyledInput = styled(Input)`
  height: 36px;
  padding-right: 80px;
  width: 100%;

  &.ant-input {
    border: none;
    border-bottom: 1px solid #d9d9d9;
    border-radius: 0;

    &:hover,
    &:focus-visible,
    &:focus {
      outline: none;
      box-shadow: none;
    }
  }
`
const StyledInputNumber = styled(InputNumber)`
  height: 36px;
  padding-right: 80px;
  width: 100%;

  &.ant-input {
    border: none;
    border-bottom: 1px solid #d9d9d9;
    border-radius: 0;

    &:hover,
    &:focus-visible,
    &:focus {
      outline: none;
      box-shadow: none;
    }
  }
`
const StyledSelect = styled(Select)`
  position: absolute;
  margin-left: 2px;
  right: 0;
  z-index: 2;
  bottom: 4px;
  width: 75px !important;
  &.ant-select {
    .ant-select-selector {
      height: 34px;
      border-color: var(--color-primary-108);
    }

    .ant-select-selection-item {
      line-height: 32px;
    }
  }
`
interface IProps extends InputProps {
  title?: string
  children?: ReactNode
  placeholder?: string
  options?: Array<any>
  defaultValue?: any | IOptionItem
  typeInput?: 'number' | 'string'
  fixed?: number
  onChangeOption?: (value: any) => void
}
const SelectInput = (props: IProps) => {
  const {
    options,
    onChangeOption,
    typeInput,
    title,
    placeholder,
    defaultValue,
    fixed,
    ...resProps
  } = props
  return (
    <StyledContainer>
      <StyleLabel>{title}</StyleLabel>
      <StyledSelectInput>
        {typeInput === 'number' && (
          <StyledInputNumber
            size="small"
            className="search-input"
            placeholder={placeholder}
            fixed={fixed}
            {...resProps}
          />
        )}
        {typeInput !== 'number' && (
          <StyledInput
            size="small"
            className="search-input"
            placeholder={placeholder}
            {...resProps}
          />
        )}

        <StyledSelect
          options={options}
          defaultValue={options?.[0]}
          onChange={onChangeOption}
        />
      </StyledSelectInput>
    </StyledContainer>
  )
}

export default SelectInput
